const random = (n: number) => {
    if (n === 0) return 0;
    return Math.abs(Math.floor(Math.random() * (n - 1) + 0));
};
export default random;
